import React from "react"
import {ItemRenderer, Select} from "@blueprintjs/select"
import {$enum} from "ts-enum-util"
import {MenuItem} from "@blueprintjs/core"
import Props from "../../../core/components/props"
import MinimalButton from "../../../core/components/buttons/MinimalButton"
import {
    ExportFileType,
    getDescription,
} from "../../../shared/enums/exportFileType"

const Combobox = Select.ofType<ExportFileType>()

export interface ExportFileTypeSelectProps extends Props {
    selectedValue: ExportFileType
    setSelectedValue: (value: ExportFileType) => void
}

const ExportFileTypeSelect: React.FC<ExportFileTypeSelectProps> = (props) => {
    const {className, id, selectedValue, setSelectedValue} = props
    const renderValueType: ItemRenderer<ExportFileType> = (
        exportFileType,
        {handleClick, modifiers, query}
    ) => {
        if (!modifiers.matchesPredicate) {
            return null
        }
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                text={getDescription(exportFileType)}
                key={exportFileType}
                onClick={handleClick}
                shouldDismissPopover={false}
            />
        )
    }

    return (
        <div>
            <Combobox
                className={className}
                items={$enum(ExportFileType).getValues()}
                itemRenderer={renderValueType}
                onItemSelect={(exportFileType: ExportFileType) =>
                    setSelectedValue(exportFileType)
                }
                activeItem={selectedValue}
                filterable={false}
            >
                <MinimalButton
                    rightIcon="caret-down"
                    text={
                        selectedValue
                            ? getDescription(selectedValue)
                            : undefined
                    }
                    id={id}
                />
            </Combobox>
        </div>
    )
}

export default ExportFileTypeSelect
